'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _RequiredOnboardingSection = require('pricing-pages-unified-ui/components/calculator/RequiredOnboardingSection');

var _RequiredOnboardingSection2 = _interopRequireDefault(_RequiredOnboardingSection);

var _GrowthSuiteEditionOnboardingMerchIdMap = require('pricing-pages-unified-ui/constants/GrowthSuiteEditionOnboardingMerchIdMap');

var _GrowthSuiteEditionOnboardingMerchIdMap2 = _interopRequireDefault(_GrowthSuiteEditionOnboardingMerchIdMap);

var _GrowthSuiteEditionTermIdMap = require('pricing-pages-unified-ui/constants/GrowthSuiteEditionTermIdMap');

var _GrowthSuiteEditionTermIdMap2 = _interopRequireDefault(_GrowthSuiteEditionTermIdMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SuiteCalcRequiredOnboardingSectionContainer = function SuiteCalcRequiredOnboardingSectionContainer(_ref) {
  var activeEdition = _ref.activeEdition,
      activeTerm = _ref.activeTerm;

  var onboardingMerchId = _GrowthSuiteEditionOnboardingMerchIdMap2.default[activeEdition];

  var termId = _GrowthSuiteEditionTermIdMap2.default[activeEdition][activeTerm];

  if (!onboardingMerchId || !termId) return null;

  return _react2.default.createElement(_RequiredOnboardingSection2.default, {
    requiredOnboardingMerchId: onboardingMerchId,
    activeTermId: termId
  });
};

SuiteCalcRequiredOnboardingSectionContainer.propTypes = {
  activeEdition: _react.PropTypes.string.isRequired,
  activeTerm: _react.PropTypes.string.isRequired
};

exports.default = SuiteCalcRequiredOnboardingSectionContainer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/growth-suite-page/SuiteCalcRequiredOnboardingSectionContainer.js
// module id = 785
// module chunks = 3 4